/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";

export function PartnerEditDialogHeader({ id }) {
  const [title, setTitle] = useState("");
  // Channel Redux state
  const { partnerForEdit, actionsLoading } = useSelector(
    (state) => ({
      partnerForEdit: state.partner.partnerForEdit,
      actionsLoading: state.channels.actionsLoading,
    }),
    shallowEqual
  );

  useEffect(() => {
    let _title = id ? "" : "Mitra Baru";
    if (partnerForEdit && id) {
      _title = "Edit Mitra";
    }

    setTitle(_title);
    // eslint-disable-next-line
  }, [partnerForEdit, actionsLoading]);

  return (
    <>
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="modal-sizes-title-lg">{title}</Modal.Title>
      </Modal.Header>
    </>
  );
}
